var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 0C3.52065 0 2.82118 0.289731 2.30546 0.805456C1.78973 1.32118 1.5 2.02065 1.5 2.75V12C0.671573 12 0 12.6716 0 13.5V18C0 18.8284 0.671572 19.5 1.5 19.5L1.5 21.25C1.5 21.9793 1.78973 22.6788 2.30546 23.1945C2.82118 23.7103 3.52065 24 4.25 24H18.25C18.9793 24 19.6788 23.7103 20.1945 23.1945C20.7103 22.6788 21 21.9793 21 21.25V6.75C21 6.55109 20.921 6.36032 20.7803 6.21967L14.7803 0.21967C14.6397 0.0790176 14.4489 0 14.25 0H4.25ZM15 12H3V2.75C3 2.41848 3.1317 2.10054 3.36612 1.86612C3.60054 1.6317 3.91848 1.5 4.25 1.5H13.5V6.74998C13.5 7.16419 13.8358 7.49998 14.25 7.49998H19.5V21.25C19.5 21.5815 19.3683 21.8994 19.1339 22.1339C18.8995 22.3683 18.5815 22.5 18.25 22.5H4.25C3.91848 22.5 3.60054 22.3683 3.36612 22.1339C3.1317 21.8994 3 21.5815 3 21.25V19.5H15C15.8284 19.5 16.5 18.8284 16.5 18V13.5C16.5 12.6716 15.8284 12 15 12ZM18.4393 5.99998L15 2.56066V5.99998H18.4393ZM15 13.5H1.5L1.5 18H15V13.5ZM3.75 15C3.33579 15 3 15.3358 3 15.75C3 16.1642 3.33579 16.5 3.75 16.5H8.25C8.66421 16.5 9 16.1642 9 15.75C9 15.3358 8.66421 15 8.25 15H3.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document-type.5c00dae4727d05daa8023f2241900c85.svg";